import { render, staticRenderFns } from "./QuizzesUpdate.vue?vue&type=template&id=32c56a50&"
import script from "./QuizzesUpdate.vue?vue&type=script&lang=js&"
export * from "./QuizzesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports